// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    BasicEnrollmentDeactivateRequest,
    BasicEnrollmentDeactivateResponse,
    BasicEnrollmentRequest,
    BasicEnrollmentResponse,
    BasicExpressEnrollmentRequest,
    ChangeProgramTypeRequestModel,
    EServicesEnrollmentRequestModel,
    EnrollPatientRequestModel,
    EnrollmentEServicesEnrollmentEnrollResponse,
    EnrollmentEditorEnrollmentEditorChangeProgramTypeResponse,
    EnrollmentEnrollmentCheckMemberNumberDefaultResponse,
    EnrollmentEnrollmentEnrollPatientDefaultResponse,
    EnrollmentEnrollmentGetBestEnrollmentDefaultResponse,
    EnrollmentEnrollmentGetBestEnrollmentsV2DefaultResponse,
    EnrollmentPaymentPaymentMethodResponse,
    EnrollmentStatusResponseModel,
    EnrollmentV1BasicEnrollmentArray,
    EnrollmentV2IsValidMemberNumberRequestModel,
    EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse,
    EnrollmentV2TransmitSendResponse,
    EnrollmentWithEmailSignaturePdfRequest,
    EnrollmentWithEmailSignatureTemplateRequest,
    EnrollmentWithSignatureUpload,
    GatewayError,
    GetBestEnrollmentRequest,
    GetBestEnrollmentV2RequestModel,
    GetEnrollmentByExternalIdRequestModel,
    GetEnrollmentStatusRequestModel,
    TransmitEnrollmentRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeEnrollmentApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param basicEnrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientEnrollmentCreateEnrollment (basicEnrollmentRequest: BasicEnrollmentRequest, xProgramId?: string): Promise<AxiosResponse<BasicEnrollmentResponse>> {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/createEnrollment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'basicEnrollmentRequest' is not null or undefined
        if (basicEnrollmentRequest === null || basicEnrollmentRequest === undefined) {
            throw new Error('Required parameter basicEnrollmentRequest was null or undefined when calling clientEnrollmentCreateEnrollment.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(basicEnrollmentRequest, "BasicEnrollmentRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<BasicEnrollmentResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentResponse");
        }
        return response;
    }
    /**
     * 
     * @param basicExpressEnrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientEnrollmentCreateExpressEnrollment (basicExpressEnrollmentRequest: BasicExpressEnrollmentRequest, xProgramId?: string): Promise<AxiosResponse<BasicEnrollmentResponse>> {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/createExpressEnrollment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'basicExpressEnrollmentRequest' is not null or undefined
        if (basicExpressEnrollmentRequest === null || basicExpressEnrollmentRequest === undefined) {
            throw new Error('Required parameter basicExpressEnrollmentRequest was null or undefined when calling clientEnrollmentCreateExpressEnrollment.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(basicExpressEnrollmentRequest, "BasicExpressEnrollmentRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<BasicEnrollmentResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentResponse");
        }
        return response;
    }
    /**
     * 
     * @param basicEnrollmentDeactivateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientEnrollmentDeactivateEnrollment (basicEnrollmentDeactivateRequest: BasicEnrollmentDeactivateRequest, xProgramId?: string): Promise<AxiosResponse<BasicEnrollmentDeactivateResponse>> {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/deactivateEnrollment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'basicEnrollmentDeactivateRequest' is not null or undefined
        if (basicEnrollmentDeactivateRequest === null || basicEnrollmentDeactivateRequest === undefined) {
            throw new Error('Required parameter basicEnrollmentDeactivateRequest was null or undefined when calling clientEnrollmentDeactivateEnrollment.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(basicEnrollmentDeactivateRequest, "BasicEnrollmentDeactivateRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<BasicEnrollmentDeactivateResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentDeactivateResponse");
        }
        return response;
    }
    /**
     * 
     * @param accountId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientEnrollmentGetEnrollmentByAccountId (accountId: string, xProgramId?: string): Promise<AxiosResponse<BasicEnrollmentResponse>> {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentByAccountId/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling clientEnrollmentGetEnrollmentByAccountId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<BasicEnrollmentResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentResponse");
        }
        return response;
    }
    /**
     * 
     * @param getEnrollmentByExternalIdRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientEnrollmentGetEnrollmentByExternalId (getEnrollmentByExternalIdRequestModel: GetEnrollmentByExternalIdRequestModel, xProgramId?: string): Promise<AxiosResponse<EnrollmentV1BasicEnrollmentArray>> {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentByExternalId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'getEnrollmentByExternalIdRequestModel' is not null or undefined
        if (getEnrollmentByExternalIdRequestModel === null || getEnrollmentByExternalIdRequestModel === undefined) {
            throw new Error('Required parameter getEnrollmentByExternalIdRequestModel was null or undefined when calling clientEnrollmentGetEnrollmentByExternalId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getEnrollmentByExternalIdRequestModel, "GetEnrollmentByExternalIdRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentV1BasicEnrollmentArray>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentV1BasicEnrollmentArray");
        }
        return response;
    }
    /**
     * 
     * @param memberNumber 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientEnrollmentGetEnrollmentByMemberNumber (memberNumber: string, xProgramId?: string): Promise<AxiosResponse<BasicEnrollmentResponse>> {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentByMemberNumber/{memberNumber}'
            .replace('{' + 'memberNumber' + '}', encodeURIComponent(String(memberNumber)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'memberNumber' is not null or undefined
        if (memberNumber === null || memberNumber === undefined) {
            throw new Error('Required parameter memberNumber was null or undefined when calling clientEnrollmentGetEnrollmentByMemberNumber.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<BasicEnrollmentResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentResponse");
        }
        return response;
    }
    /**
     * 
     * @param getEnrollmentStatusRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientEnrollmentGetEnrollmentStatus (getEnrollmentStatusRequestModel: GetEnrollmentStatusRequestModel, xProgramId?: string): Promise<AxiosResponse<EnrollmentStatusResponseModel>> {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentStatus';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'getEnrollmentStatusRequestModel' is not null or undefined
        if (getEnrollmentStatusRequestModel === null || getEnrollmentStatusRequestModel === undefined) {
            throw new Error('Required parameter getEnrollmentStatusRequestModel was null or undefined when calling clientEnrollmentGetEnrollmentStatus.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getEnrollmentStatusRequestModel, "GetEnrollmentStatusRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentStatusResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentStatusResponseModel");
        }
        return response;
    }
    /**
     * 
     * @param accountId 
     * @param basicEnrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientEnrollmentUpdateEnrollment (accountId: number, basicEnrollmentRequest: BasicEnrollmentRequest, xProgramId?: string): Promise<AxiosResponse<BasicEnrollmentResponse>> {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/updateEnrollment/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling clientEnrollmentUpdateEnrollment.');
        }

        // verify required parameter 'basicEnrollmentRequest' is not null or undefined
        if (basicEnrollmentRequest === null || basicEnrollmentRequest === undefined) {
            throw new Error('Required parameter basicEnrollmentRequest was null or undefined when calling clientEnrollmentUpdateEnrollment.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(basicEnrollmentRequest, "BasicEnrollmentRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<BasicEnrollmentResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentResponse");
        }
        return response;
    }
    /**
     * 
     * @param eServicesEnrollmentRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async eServicesEnrollmentEnroll (eServicesEnrollmentRequestModel: EServicesEnrollmentRequestModel, xProgramId?: string): Promise<AxiosResponse<EnrollmentEServicesEnrollmentEnrollResponse>> {
        const _url_ = '/edge/enrollment/EServicesEnrollment/enroll';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'eServicesEnrollmentRequestModel' is not null or undefined
        if (eServicesEnrollmentRequestModel === null || eServicesEnrollmentRequestModel === undefined) {
            throw new Error('Required parameter eServicesEnrollmentRequestModel was null or undefined when calling eServicesEnrollmentEnroll.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(eServicesEnrollmentRequestModel, "EServicesEnrollmentRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentEServicesEnrollmentEnrollResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentEServicesEnrollmentEnrollResponse");
        }
        return response;
    }
    /**
     * 
     * @param enrollmentV2IsValidMemberNumberRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentCheckMemberNumber (enrollmentV2IsValidMemberNumberRequestModel: EnrollmentV2IsValidMemberNumberRequestModel, xProgramId?: string): Promise<AxiosResponse<EnrollmentEnrollmentCheckMemberNumberDefaultResponse>> {
        const _url_ = '/edge/enrollment/CheckMemberNumber';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'enrollmentV2IsValidMemberNumberRequestModel' is not null or undefined
        if (enrollmentV2IsValidMemberNumberRequestModel === null || enrollmentV2IsValidMemberNumberRequestModel === undefined) {
            throw new Error('Required parameter enrollmentV2IsValidMemberNumberRequestModel was null or undefined when calling enrollmentCheckMemberNumber.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentV2IsValidMemberNumberRequestModel, "EnrollmentV2IsValidMemberNumberRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentEnrollmentCheckMemberNumberDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentEnrollmentCheckMemberNumberDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param changeProgramTypeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentEditorChangeProgramType (changeProgramTypeRequestModel: ChangeProgramTypeRequestModel, xProgramId?: string): Promise<AxiosResponse<EnrollmentEditorEnrollmentEditorChangeProgramTypeResponse>> {
        const _url_ = '/edge/enrollment/editor/enrollmentEditor/changeProgramType';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'changeProgramTypeRequestModel' is not null or undefined
        if (changeProgramTypeRequestModel === null || changeProgramTypeRequestModel === undefined) {
            throw new Error('Required parameter changeProgramTypeRequestModel was null or undefined when calling enrollmentEditorChangeProgramType.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(changeProgramTypeRequestModel, "ChangeProgramTypeRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentEditorEnrollmentEditorChangeProgramTypeResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentEditorEnrollmentEditorChangeProgramTypeResponse");
        }
        return response;
    }
    /**
     * 
     * @param enrollPatientRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentEnrollPatient (enrollPatientRequestModel: EnrollPatientRequestModel, xProgramId?: string): Promise<AxiosResponse<EnrollmentEnrollmentEnrollPatientDefaultResponse>> {
        const _url_ = '/edge/enrollment/EnrollPatient';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'enrollPatientRequestModel' is not null or undefined
        if (enrollPatientRequestModel === null || enrollPatientRequestModel === undefined) {
            throw new Error('Required parameter enrollPatientRequestModel was null or undefined when calling enrollmentEnrollPatient.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollPatientRequestModel, "EnrollPatientRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentEnrollmentEnrollPatientDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentEnrollmentEnrollPatientDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param getBestEnrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentGetBestEnrollment (getBestEnrollmentRequest: GetBestEnrollmentRequest, xProgramId?: string): Promise<AxiosResponse<EnrollmentEnrollmentGetBestEnrollmentDefaultResponse>> {
        const _url_ = '/edge/enrollment/GetBestEnrollment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'getBestEnrollmentRequest' is not null or undefined
        if (getBestEnrollmentRequest === null || getBestEnrollmentRequest === undefined) {
            throw new Error('Required parameter getBestEnrollmentRequest was null or undefined when calling enrollmentGetBestEnrollment.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getBestEnrollmentRequest, "GetBestEnrollmentRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentEnrollmentGetBestEnrollmentDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentEnrollmentGetBestEnrollmentDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param getBestEnrollmentV2RequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentGetBestEnrollmentsV2 (getBestEnrollmentV2RequestModel: GetBestEnrollmentV2RequestModel, xProgramId?: string): Promise<AxiosResponse<EnrollmentEnrollmentGetBestEnrollmentsV2DefaultResponse>> {
        const _url_ = '/edge/enrollment/GetBestEnrollmentsV2';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'getBestEnrollmentV2RequestModel' is not null or undefined
        if (getBestEnrollmentV2RequestModel === null || getBestEnrollmentV2RequestModel === undefined) {
            throw new Error('Required parameter getBestEnrollmentV2RequestModel was null or undefined when calling enrollmentGetBestEnrollmentsV2.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getBestEnrollmentV2RequestModel, "GetBestEnrollmentV2RequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentEnrollmentGetBestEnrollmentsV2DefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentEnrollmentGetBestEnrollmentsV2DefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param enrollmentWithEmailSignaturePdfRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientEnrollmentEnrollmentWithEmailSignaturePdfRequest (enrollmentWithEmailSignaturePdfRequest: EnrollmentWithEmailSignaturePdfRequest, xProgramId?: string): Promise<AxiosResponse<EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse>> {
        const _url_ = '/edge/enrollment/v2/patient/enrollmentWithEmailSignaturePdfRequest';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'enrollmentWithEmailSignaturePdfRequest' is not null or undefined
        if (enrollmentWithEmailSignaturePdfRequest === null || enrollmentWithEmailSignaturePdfRequest === undefined) {
            throw new Error('Required parameter enrollmentWithEmailSignaturePdfRequest was null or undefined when calling patientEnrollmentEnrollmentWithEmailSignaturePdfRequest.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentWithEmailSignaturePdfRequest, "EnrollmentWithEmailSignaturePdfRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse");
        }
        return response;
    }
    /**
     * 
     * @param enrollmentWithEmailSignatureTemplateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientEnrollmentEnrollmentWithEmailSignatureTemplateRequest (enrollmentWithEmailSignatureTemplateRequest: EnrollmentWithEmailSignatureTemplateRequest, xProgramId?: string): Promise<AxiosResponse<EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse>> {
        const _url_ = '/edge/enrollment/v2/patient/enrollmentWithEmailSignatureTemplateRequest';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'enrollmentWithEmailSignatureTemplateRequest' is not null or undefined
        if (enrollmentWithEmailSignatureTemplateRequest === null || enrollmentWithEmailSignatureTemplateRequest === undefined) {
            throw new Error('Required parameter enrollmentWithEmailSignatureTemplateRequest was null or undefined when calling patientEnrollmentEnrollmentWithEmailSignatureTemplateRequest.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentWithEmailSignatureTemplateRequest, "EnrollmentWithEmailSignatureTemplateRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse");
        }
        return response;
    }
    /**
     * 
     * @param enrollmentWithSignatureUpload default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientEnrollmentEnrollmentWithSignatureDocumentUpload (enrollmentWithSignatureUpload: EnrollmentWithSignatureUpload, xProgramId?: string): Promise<AxiosResponse<EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse>> {
        const _url_ = '/edge/enrollment/v2/patient/enrollmentWithSignatureDocumentUpload';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'enrollmentWithSignatureUpload' is not null or undefined
        if (enrollmentWithSignatureUpload === null || enrollmentWithSignatureUpload === undefined) {
            throw new Error('Required parameter enrollmentWithSignatureUpload was null or undefined when calling patientEnrollmentEnrollmentWithSignatureDocumentUpload.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentWithSignatureUpload, "EnrollmentWithSignatureUpload"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async paymentPaymentMethod (xProgramId?: string): Promise<AxiosResponse<EnrollmentPaymentPaymentMethodResponse>> {
        const _url_ = '/edge/enrollment/Payment/PaymentMethod';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentPaymentPaymentMethodResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentPaymentPaymentMethodResponse");
        }
        return response;
    }
    /**
     * 
     * @param transmitEnrollmentRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async transmitEnrollmentSend (transmitEnrollmentRequest: TransmitEnrollmentRequest, xProgramId?: string): Promise<AxiosResponse<EnrollmentV2TransmitSendResponse>> {
        const _url_ = '/edge/enrollment/v2/transmit/send';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'transmitEnrollmentRequest' is not null or undefined
        if (transmitEnrollmentRequest === null || transmitEnrollmentRequest === undefined) {
            throw new Error('Required parameter transmitEnrollmentRequest was null or undefined when calling transmitEnrollmentSend.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(transmitEnrollmentRequest, "TransmitEnrollmentRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentV2TransmitSendResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentV2TransmitSendResponse");
        }
        return response;
    }
}
